<template>
  <div
    v-if="badge"
    class="badge type-body-small ttu lh-title absolute top-0 right-0 mt3 mr3 bg-sold-out same-as-bg"
    :class="badge.classes"
  >
    {{ badge.text }}
  </div>
</template>

<script>
  export default {
    props: {
      product: {
        type: Object,
        required: true,
      },
    },

    data() {
      // Shopify handleized version of badge::
      const badgePrefix = 'badge-';

      return {
        badge: {
          classes: '',
          text: '',
        },
        badgePrefix,
        badgePriority: [
          {
            tag: `${badgePrefix}On Sale`,
            text: 'Sale'
          },
          {
            tag: `${badgePrefix}new`,
            text: 'New'
          },
          {
            tag: `${badgePrefix}best-seller`,
            text: 'Best Seller'
          },
          {
            tag: `${badgePrefix}preorder`,
            text: 'Preorder'
          },
          {
            tag: `${badgePrefix}coming-soon`,
            text: 'Coming Soon'
          },
        ],
        customBadgePreffix: 'custom::'
      };
    },

    computed: {
      productIsAvailable() {
        return this.product.available;
      },

      productIsOnSale() {
        return this.product.compare_at_price > this.product.price;
      },
    },

    mounted() {
      this.initBadge();
    },

    updated() {
      this.initBadge();
    },

    methods: {
      initBadge() {
        const customBadge = this.getFirstCustomTag();

        if (customBadge && customBadge.length) {
          this.setBadge(customBadge.replace(this.customBadgePreffix, ''), 'badge--custom');
          return;
        }
        if (!this.productIsAvailable) {
          this.setBadge(window.bvaccel.language.sold_out_badge_text, 'badge--sold-out');
          return;
        }
        const validBadge = this.badgePriority.find((badge) => {
          if (this.product.handleized_tags) {
          return this.product.handleized_tags.includes(badge.tag);
          } else {
          }
        })

        if (validBadge) {
          this.setBadge(validBadge.text, `badge--${validBadge.tag.replace(this.badgePrefix, '')}`);
          return;
        } 

        this.productIsOnSale ? this.setBadge(window.bvaccel.language.on_sale_badge_text, 'badge--sale') : this.badge = null;
      },

      getFirstCustomTag() {
        if (!this.product.tags || this.product.tags.length === 0) {
          return [];
        }

        return this.product.tags.find((tag) => tag.includes(this.customBadgePreffix));
      },

      setBadge(text, classes) {
        this.badge.text = text;
        this.badge.classes = classes;
      }
    },
  };
</script>

<style></style>
